/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_Gps_DescriptionInputs */

const fr_help_position_gps_description = /** @type {(inputs: Help_Position_Gps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position réelle (GPS du bus)`)
};

const en_help_position_gps_description = /** @type {(inputs: Help_Position_Gps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real position (bus GPS)`)
};

/**
* | output |
* | --- |
* | "Real position (bus GPS)" |
*
* @param {Help_Position_Gps_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_gps_description = /** @type {((inputs?: Help_Position_Gps_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_Gps_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_gps_description(inputs)
	return en_help_position_gps_description(inputs)
});